module.exports = __webpack_public_path__ + "assets/flags/es.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/es.svg
// module id = 499
// module chunks = 0